import React from "react";
import Head from "../../football/match/Head";
import TennisInfoTable from "../../tennis/TennisInfoTable";
import TennisStats from "../../tennis/TennisStats";
import TennisRankings from "../../tennis/TennisRankings";

const TennisMatchWidgetWrap = (props) => {
  const {
    dataId,
    dataType,
    head,
    data,
    headData,
    sport,
    difference,
    loadCSS,
    dataClient,
    websiteBaseUrl,
    dataPath,
    dataTitle,
    socketUrl,
    channel,
    event,
  } = props;

  const renderHeadWrap = (currentTab, children) =>
    head ? (
      <Head
        matchDetail={headData}
        difference={difference}
        sport={sport}
        dataClient={dataClient}
        id={dataId}
        currentTab={currentTab}
        websiteBaseUrl={websiteBaseUrl}
        dataPath={dataPath}
        title={dataTitle}
        socketUrl={socketUrl}
        channel={channel}
        event={event}
      >
        {children}
      </Head>
    ) : (
      <>{children}</>
    );

  switch (dataType) {
    case "tennis-match-info":
      return renderHeadWrap("info",
        <TennisInfoTable
          ServerData={data?.data}
          loadCSS={loadCSS}
          dataClient={dataClient}
          difference={difference}
          title={dataTitle}
          sport={sport}

        />
      );
    case "tennis-match":
      return (head && (<Head
        matchDetail={headData}
        difference={difference}
        sport={sport}
        dataClient={dataClient}
        id={dataId}
        websiteBaseUrl={websiteBaseUrl}
        dataPath={dataPath}
        title={dataTitle}
      />))
    case "tennis-match-stats":
      return renderHeadWrap("stats",
        <TennisStats
          data={data?.data}
          loadCSS={loadCSS}
          dataClient={dataClient}
          title={dataTitle}
        />
      );
    case "tennis-rankings":
      return (
        <TennisRankings
          data={data?.data}
          loadCSS={loadCSS}
          dataClient={dataClient}
          title={dataTitle}
        />
      );
    default:
      return <h1>Tennis Match Widget Not Found!</h1>;
  }
};

export default TennisMatchWidgetWrap;
